import React from 'react'
import DetailContainerStyles from './detail.module.css'
import {ReactComponent as Arrow} from 'images/icons/arrow.svg'
const DetailContainer = React.forwardRef((props,ref) => {
  return  (
    <div ref={ref} className={DetailContainerStyles.container}>
      <div className={DetailContainerStyles.content}>
    {props.children}
      </div>
      <div className={DetailContainerStyles.buttons}>
        <button onClick={props.onClose}>
          <Arrow className={DetailContainerStyles.arrow}/>
          <span>Close</span>
        </button>
      </div>
    </div>
  )
})


export default DetailContainer
